import {cssColorValues} from 'components/system/colors';
import {IconProps} from './props';

export const LockIcon = ({
  color = 'greyDark',
  width = '24',
  height = '24',
  className,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.50654 6.88683C8.89106 7.30158 8.6 7.81071 8.6 8.29545V12.3386H7.4V8.29545C7.4 7.29096 8.00394 6.45236 8.83596 5.89169C9.67151 5.32864 10.7919 5 12 5C13.2081 5 14.3285 5.32864 15.164 5.89169C15.9961 6.45236 16.6 7.29096 16.6 8.29545V12.3386H15.4V8.29545C15.4 7.81071 15.1089 7.30158 14.4935 6.88683C13.8815 6.47446 13.0019 6.2 12 6.2C10.9981 6.2 10.1185 6.47446 9.50654 6.88683ZM7 19.0773C6.45 19.0773 6 18.774 6 18.4034V13.0125C6 12.6419 6.45 12.3386 7 12.3386H17C17.55 12.3386 18 12.6419 18 13.0125V18.4034C18 18.774 17.55 19.0773 17 19.0773H7ZM12.6 16.3818C12.6 16.0504 12.3314 15.7818 12 15.7818C11.6686 15.7818 11.4 16.0504 11.4 16.3818V17.0557C11.4 17.387 11.6686 17.6557 12 17.6557C12.3314 17.6557 12.6 17.387 12.6 17.0557V16.3818Z'
        fill={cssColorValues[color]}
      />
    </svg>
  );
};
